// DictionnaryList
import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  InputGroup,
  Button,
  Badge,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { useContext } from "react";
import { dictionaryService } from "../../services/api";
import "../../styles/DictionaryList.css"; // Import du fichier CSS

const DictionaryList = () => {
  const { currentUser } = useContext(AuthContext);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    if (currentUser) {
      const isAdmin = currentUser.profile.role === "admin";
      console.log("is", isAdmin);
      setIsAdmin(isAdmin);
    }
  }, [currentUser]);

  const navigate = useNavigate();
  const [entries, setEntries] = useState([]);
  const [page, setPage] = useState(1);
  const [max_entries, setMaxEntries] = useState(11);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filters, setFilters] = useState({
    wordType: "",
    region: "",
    status: "",
  });

  useEffect(() => {
    const fetchEntries = async () => {
      try {
        setLoading(true);
        const params = new URLSearchParams();
        params.append("page", page);
        if (searchTerm) params.append("q", searchTerm);
        params.append("status", "validated");
        const response = await dictionaryService.getAllEntries(params);
        console.log("Réponse de l'API:", response.data);
        setEntries(response.data.results);
        setMaxEntries(response.data.count);
        setError(null);
      } catch (err) {
        setError("Impossible de charger les entrées.");
      } finally {
        setLoading(false);
      }
    };
    fetchEntries();
  }, [searchTerm, filters, page, isAdmin]);
  const LoginModal = () => (
   <div style={{
     position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
      background: 'rgba(0,0,0,0.5)', zIndex: 1000,
      display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}>
    <div style={{
      background: 'white', borderRadius: '20px', padding: '2.5rem',
      maxWidth: '420px', width: '90%', textAlign: 'center',
      boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
      animation: 'fadeInUp 0.3s ease'
    }}>
    <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🔒</div>
    <h3 style={{
        color: '#2c3e50', fontFamily: 'Georgia, serif',
        fontSize: '1.5rem', marginBottom: '0.8rem'
    }}>
        Accès restreint
    </h3>
    <p style={{ color: '#7f8c8d', fontSize: '1rem', marginBottom: '2rem' }}>
        Connectez-vous pour accéder aux détails des mots du dictionnaire.
    </p>
    <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
        <button
          onClick={() => setShowLoginModal(false)}
          style={{
            padding: '0.8rem 1.8rem', borderRadius: '25px', border: '2px solid #bdc3c7',
            background: 'white', color: '#7f8c8d', fontWeight: '600',
            cursor: 'pointer', fontSize: '0.95rem'
        }}
        >
          Annuler
        </button>
        <button
          onClick={() => navigate('/login')}
          style={{
            padding: '0.8rem 1.8rem', borderRadius: '25px', border: 'none',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white', fontWeight: '600', cursor: 'pointer',
            fontSize: '0.95rem', boxShadow: '0 4px 15px rgba(102,126,234,0.4)'
          }}
        >
          Se connecter
        </button>
      </div>
    </div>
  </div>
);
return (
   <div className="dictionary-container">
    {showLoginModal && <LoginModal />}
    
      <div className="my-5 dict-page">
        <div className="content-wrapper">
          <h1 className="dictionary-title">
            Exploiter la Richesse du Dialecte Algerien Sur DzWordnet
          </h1>

          {/* Barre de recherche stylisée */}
          <div className="dict-searchbar">
            <input
              type="text"
              placeholder="Rechercher un terme dans le dictionnaire"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
              }}
            />
            <span className="dict-search-ico">
              <FontAwesomeIcon icon={faSearch} />
            </span>
          </div>

          {/* Messages d'état */}
          {loading && (
            <div className="loading-message">
              Chargement des entrées du dictionnaire...
            </div>
          )}

          {entries.length === 0 && !loading && (
            <div className="no-entries-message">
              Aucune entrée trouvée dans le dictionnaire.
            </div>
          )}

          {/* Tableau des entrées */}
          {entries.length > 0 && !loading && (
            <div className="dictionary-table-container">
              <table className="dictionary-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Mot Darija</th>
                    <th>Mot Fusha (MSA)</th>
                    <th>Mot Français</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {entries.map((entry, index) => (
                    <tr key={entry.id}>
                      <td data-label="ID">
                        <span className="entry-id">#{entry.id}</span>
                      </td>
                      <td data-label="Mot Darija">
                        <div className="arabic-word">{entry.arabic_word}</div>
                      </td>
                      <td data-label="Mot Fusha (MSA)">
                        <div className="arabic-word">
                         {entry.details?.word_ar_msa || "—"}
                        </div>
                      </td>
                      <td data-label="Mot Français">
                       <div className="french-word">
                         {entry.translation || entry.french_translation || "Non traduit"}
                      </div>
                    </td>
                      <td data-label="">
                        <Button
                          className="detail-button"
                          onClick={() => {
                            if (!currentUser) {
                              setShowLoginModal(true);
                              return;
                            }
                            navigate(`/dictionary/${entry.id}`);
                          }}
                        >
                          Voir Détails
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Espaceur pour pousser le contenu */}
          <div className="content-spacer"></div>

          {/* Bouton Charger plus */}
          {max_entries > page * 10 && !loading && (
            <div className="load-more-container">
              <Button
                className="load-more-button"
                onClick={() => setPage(page + 1)}
              >
                Charger Plus d'Entrées
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
);
};

export default DictionaryList;